import RewardPage from './RewardPage';

export default RewardPage;
